module.exports = __webpack_public_path__ + "img/aboutimg3.4cea6252.jpg";